import { render } from "./StepNav.vue?vue&type=template&id=b908e56e&scoped=true"
import script from "./StepNav.vue?vue&type=script&lang=js"
export * from "./StepNav.vue?vue&type=script&lang=js"

import "./StepNav.vue?vue&type=style&index=0&id=b908e56e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b908e56e"]])

export default __exports__